module.exports = __webpack_public_path__ + "static/media/FitnessGirl-3.5409a4db.jpg";